import { msalInstance } from '../../App';

export class NotificationBlackoutService {

    async invokeWebAPI(url, httpMethod, msalContext, body = "") {

        // check if msalContext exists
        if (msalContext.accounts.length > 0) {
            const tokenRequest = {
                scopes: [global.ENV_MSAL_LOGIN_REQUEST_SCOPES],
                account: msalContext.accounts[0],
            };

            // acquire Bearer token to include in GET request
            const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
            const token = tokenResponse.accessToken;
            const bearer = `Bearer ${token}`;
            const headers = new Headers();
            headers.append('Accept', '*/*');
            headers.append('Content-Type', 'application/json');
            headers.append('x-northwell-version', '1.0');
            headers.append("Authorization", bearer);
            headers.append('User', msalContext.accounts[0].username)

            var options = {}
            if (body) {
                options = {
                    method: httpMethod,
                    headers: headers,
                    body: body
                };
            } else {
                options = {
                    method: httpMethod,
                    headers: headers
                };
            }

            let response = await fetch(url, options);

            return {
                status: response.status,
                body: await response.json()
            };

        } else {
            console.log('user not logged in')
        }
    }

    async getMetricType(sourcesystem, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/MetricsRead/MetricTypes?SourceSystem=" + sourcesystem
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getHIEInstances(environment, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/metricsread/HIEInstances?environment=" + environment
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getProductions(instance, environment, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/metricsread/ProductionStatus?instance=" + instance + "&environment=" + environment
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getProductionItems(instance, nameSpace, environment, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/productionitem?instance=" + instance + "&nameSpace=" + nameSpace + "&environment=" + environment
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNotificationBlackoutRules(msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Blackout"
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNotificationBlackoutRule(Id, details, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Blackout/" + Id + "?details=" + details
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async createNotificationBlackoutRule(body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Blackout/"
        try {
            const response = await this.invokeWebAPI(url, 'POST', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async editNotificationBlackoutRule(Id, body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Blackout/" + Id
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
}